document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 780) {
        var splide = new Splide('.shop-category-homepage__slider', {
            perPage: 4,
            breakpoints: {
                780: {
                    destroy: true,
                },
            }
        });
        splide.mount();
    }
});
